export const warrantyLimitationsandExclusions = [
  {
    header: "Use at Your Own Risk",
    answer:
      "• You use the Platform and any information obtained from it at your own risk. \n \
        • HomeSwap does not provide any warranties, express or implied, regarding Exchanges or the goods, personal or property, listed on the Platform. \n \
        • There are no warranties concerning Listings, other Members or Newcomers, or any other information available on the Platform, including accuracy and non-infringement.",
  },
  {
    header: "Content Monitoring",
    answer:
      "• HomeSwap reserves the right, but not the obligation, to pre-screen, monitor, or remove any User Content. \n \
        • Various tools and procedures are used to screen Members and Newcomers; however, HomeSwap does not conduct background checks or request references from prospects and does not verify the information posted by Members or Newcomers.",
  },
  {
    header: "Conduct and Compliance",
    answer:
      "• HomeSwap makes no representations or warranties regarding the behavior of Members or Guests or the suitability of properties listed by Members or Newcomers. \n \
        • This includes compliance with federal, state, or local laws and third-party agreements.",
  },
  {
    header: "Acceptance of Risk",
    answer:
      "• You assume full responsibility and risk for your use of the Platform and any information obtained through it, including interactions with other Members or Newcomers and participation in Exchanges. \n \
        • Your use of the Platform is voluntary and at your own risk, and some Services may carry inherent risks that you willingly accept. \n \
        • The Platform and its functionalities are provided on an 'as is' and 'as available' basis.",
  },
  {
    header: "Platform Availability",
    answer:
      "• HomeSwap cannot guarantee continuous and uninterrupted access to the Platform. \n \
        • The company reserves the right to restrict or limit access to the Platform as necessary for server protection or maintenance.",
  },
  {
    header: "Third-Party Content",
    answer:
      "Opinions, advice, statements, offers, or other information made available through the Platform, but not directly by HomeSwap, are the responsibility of their respective authors and should not be relied upon.",
  },
  {
    header: "No Endorsement",
    answer:
      "• HomeSwap does not guarantee the accuracy, completeness, or usefulness of any information on the Platform. \n \
• The company does not endorse or assume responsibility for the reliability of any opinion, advice, or statement made by parties other than HomeSwap. \n \
• HomeSwap is not liable for any loss or damage resulting from reliance on any information or content posted on the Platform or delivered to Members or Newcomers.",
  },
];
